import {Injectable} from '@angular/core';
import {
  AppNameEnum,
  AufnahmeGewerblicheTaetigkeit as AufnahmeGewerblicheTaetigkeit21,
  GruendungKapitalgesellschaft as GruendungKapitalgesellschaft21,
  GruendungPersonengesellschaft as GruendungPersonengesellschaft21,
  BeteiligungPersonengesellschaft as BeteiligungPersonengesellschaft21,
  KoerperschaftNachAuslaendischemRecht as KoerperschaftNachAuslaendischemRecht21,
  BeiEinkunftenAusEnumLabels,
  ArtDesBeteiligtenEnumLabels
} from '@nachdigal';
import {
  AufnahmeGewerblicheTaetigkeit,
  PersonenstandEnum,
  LohnsteuerAngaben,
  GrundlageVorauszahlungen,
  Inlandsadresse,
  GruendungKapitalgesellschaft,
  GruendungPersonengesellschaft,
  BeteiligungPersonengesellschaft,
  KoerperschaftNachAuslaendischemRecht,
  Auslandsadresse,
  Betriebstaette,
  Organgesellschaft,
  UmsatzsteuerAngaben,
  FestsetzungVorauszahlungAngaben,
  ArtDerBeteiligungEnum,
  BeiEinkunftenAusEnum,
  ArtDesBeteiligtenEnum,
  Aufteilungsquote,
  GesellschafterFestsetzungAngaben,
  AnlageArbeitsgemeinschaft,
  GesellschaftVertretung
} from '../model/taskdata/nutzdaten/v2020/models';
import {cloneDeep} from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ConvertOldTaskDataService {

  constructor() {
    // This is intentional
  }

  public convertNutzdaten(appName: AppNameEnum,
                          nutzdaten: AufnahmeGewerblicheTaetigkeit
                            | GruendungKapitalgesellschaft
                            | GruendungPersonengesellschaft
                            | BeteiligungPersonengesellschaft
                            | KoerperschaftNachAuslaendischemRecht) {
    try {
      switch (appName) {
        case AppNameEnum.FragebogenKapG:
          return this.convertGruendungKapitalgesellschaft(nutzdaten);
        case AppNameEnum.FragebogenPersG:
          return this.convertGruendungPersonengesellschaft(nutzdaten);
        case AppNameEnum.FragebogenBetPG:
          return this.convertBeteiligungPersonengesellschaft(nutzdaten);
        case AppNameEnum.FragebogenKapGAus:
          return this.convertKoerperschaftNachAuslaendischemRecht(nutzdaten);
        case AppNameEnum.FragebogenEUn:
          return this.convertAufnameGewerblicheTaetigkeit(nutzdaten);
        default:
          return nutzdaten;
      }
    }catch(e){
      console.error('convertNutzdaten() conversion exception', e);
      return nutzdaten;
    }
  }

  public convertGruendungKapitalgesellschaft(oldNutzdaten: GruendungKapitalgesellschaft): GruendungKapitalgesellschaft21 {

    this.updateNodeToInteger<GruendungKapitalgesellschaft>('hausnummer', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('summeUmsaetzeJahrBetriebseroeffnung', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('summeUmsaetzeFolgejahr', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('betrag', oldNutzdaten);

    this.updateNodeToInteger<GruendungKapitalgesellschaft>('hoeheGrundStammkapital', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('daraufEingezahlt', oldNutzdaten);

    this.updateNodeToInteger<GruendungKapitalgesellschaft>('gewinn', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('gewinnFj', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('zuVerstEink', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('zuVerstEinkFj', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('stAnrBetr', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('stAnrBetrFj', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('gewerbeertrag', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('gewerbeertragFj', oldNutzdaten);

    this.updateNodeToInteger<GruendungKapitalgesellschaft>('arbeitnehmer', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('familienangehoerige', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('geringfuegigBeschaeftigte', oldNutzdaten);
    this.updateNodeToInteger<GruendungKapitalgesellschaft>('voraussichtlicheLohnsteuer', oldNutzdaten);

    oldNutzdaten.anteilseignerAngaben?.anteilseigner?.forEach(anteilseigner => {
      delete anteilseigner.weitereAngabenAnteilseigner?.gruendungsdatum;
    });

    return oldNutzdaten as unknown as GruendungKapitalgesellschaft21;
  }

  public convertGruendungPersonengesellschaft(oldNutzdaten: GruendungPersonengesellschaft): GruendungPersonengesellschaft21 {
    oldNutzdaten.gesellschafternAngaben?.gesellschaftern?.forEach(gesellschafter => {
      if (gesellschafter.gesellschafterFestsetzungAngaben?.artDerBeteiligung === ArtDerBeteiligungEnum.TreuhaenderNurFuerHaftungsbeschraenkterTreugeber){
        gesellschafter.gesellschafterFestsetzungAngaben.artDerBeteiligung = null;
      }
      if (gesellschafter.gesellschafterFestsetzungAngaben?.beiEinkunftenAus){
        gesellschafter.gesellschafterFestsetzungAngaben.beiEinkunftenAus = this.convertBeiEinkuenftenAusEnum(gesellschafter.gesellschafterFestsetzungAngaben.beiEinkunftenAus);
      }
      if (gesellschafter.gesellschafterFestsetzungAngaben?.artDesBeteiligten){
        gesellschafter.gesellschafterFestsetzungAngaben.artDesBeteiligten
          = this.convertArtDesBeteiligtenEnum(gesellschafter.gesellschafterFestsetzungAngaben.artDesBeteiligten) as unknown as ArtDesBeteiligtenEnum;
      }

      this.convertToNumbersOnly<Aufteilungsquote>(gesellschafter.aufteilungsquote, 'kapitalanteilNenner');
      this.convertToNumbersOnly<Aufteilungsquote>(gesellschafter.aufteilungsquote, 'kapitalanteilZaehler');
      this.convertToNumbersOnly<GesellschafterFestsetzungAngaben>(gesellschafter.gesellschafterFestsetzungAngaben, 'gewinnanteilGruendJahr');
      this.convertToNumbersOnly<GesellschafterFestsetzungAngaben>(gesellschafter.gesellschafterFestsetzungAngaben, 'gewinnanteilFolgeJahr');
      this.convertToNumbersOnly<GesellschafterFestsetzungAngaben>(gesellschafter.gesellschafterFestsetzungAngaben, 'sonderbetriebseinnahmenGruendJahr');
      this.convertToNumbersOnly<GesellschafterFestsetzungAngaben>(gesellschafter.gesellschafterFestsetzungAngaben, 'sonderbetriebseinnahmenFolgeJahr');
      this.convertToNumbersOnly<GesellschafterFestsetzungAngaben>(gesellschafter.gesellschafterFestsetzungAngaben, 'sonderbetriebsausgabenGruendJahr');
      this.convertToNumbersOnly<GesellschafterFestsetzungAngaben>(gesellschafter.gesellschafterFestsetzungAngaben, 'sonderbetriebsausgabenFolgeJahr');
      this.convertToNumbersOnly4StandartAddressesAtHausnummer(gesellschafter);

      const newMaxLength = 999999999.99;
      if (gesellschafter.aufteilungsquote?.kapitalanteilGruendung > newMaxLength){
        delete gesellschafter.aufteilungsquote.kapitalanteilGruendung;
      }

      if (gesellschafter.aufteilungsquote?.kapitalanteilNenner === 0
        || gesellschafter.aufteilungsquote?.kapitalanteilNenner as unknown as string === '0'){
        delete gesellschafter.aufteilungsquote.kapitalanteilNenner;
      }

      if (gesellschafter.aufteilungsquote?.prozentAnteil){
        delete gesellschafter.aufteilungsquote.prozentAnteil;
      }
    });

    this.convertToNumbersOnly<LohnsteuerAngaben>(oldNutzdaten.lohnsteuerAngaben, 'voraussichtlicheLohnsteuer');
    this.convertToNumbersOnly<LohnsteuerAngaben>(oldNutzdaten.lohnsteuerAngaben, 'arbeitnehmer');
    this.convertToNumbersOnly<LohnsteuerAngaben>(oldNutzdaten.lohnsteuerAngaben, 'familienangehoerige');
    this.convertToNumbersOnly<LohnsteuerAngaben>(oldNutzdaten.lohnsteuerAngaben, 'geringfuegigBeschaeftigte');
    this.convertToNumbersOnly<AnlageArbeitsgemeinschaft>(oldNutzdaten.anlageArbeitsgemeinschaft, 'auftragsvolumenGesamt');
    this.convertToNumbersOnly<AnlageArbeitsgemeinschaft>(oldNutzdaten.anlageArbeitsgemeinschaft, 'auftragsvolumenFolgeJahr');
    this.convertToNumbersOnly<AnlageArbeitsgemeinschaft>(oldNutzdaten.anlageArbeitsgemeinschaft, 'auftragsvolumenGruendJahr');
    this.convertToNumbersOnly<UmsatzsteuerAngaben>(oldNutzdaten.umsatzsteuerAngaben, 'summeUmsaetzeJahrBetriebseroeffnung');
    this.convertToNumbersOnly<UmsatzsteuerAngaben>(oldNutzdaten.umsatzsteuerAngaben, 'summeUmsaetzeFolgejahr');
    this.convertToNumbersOnly<UmsatzsteuerAngaben>(oldNutzdaten.umsatzsteuerAngaben, 'betrag');
    this.convertToNumbersOnly<Inlandsadresse>(oldNutzdaten.gruendungsformAngaben?.vorherigesUnternehmenAdresse, 'hausnummer');
    this.convertToNumbersOnly<Inlandsadresse>(oldNutzdaten.lohnsteuerAngaben?.betriebstaetteInlandsadresse, 'hausnummer');

    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.abweichenderOrtGeschaeftsleitungAngaben);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.empfangsbevollmaechtigterAngaben);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.angabenZumUnternehmen);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.angabenZumUnternehmen);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.anlageArbeitsgemeinschaft);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.steuerlicheBeratungAngaben);

    oldNutzdaten.gesellschaftVertretungAngaben?.gesellschaftVertretungen.forEach(vertretung => {
      this.convertToNumbersOnly4StandartAddressesAtHausnummer<GesellschaftVertretung>(vertretung);
    });

    oldNutzdaten.betriebstaettenAngaben?.betriebstaetten.forEach(bs => {
      this.convertToNumbersOnly4StandartAddressesAtHausnummer<Betriebstaette>(bs);
    });

    oldNutzdaten.organschaftAngaben?.organgesellschaften.forEach(og => {
      this.convertOrgangesellschaften(og);
    });

    return oldNutzdaten as unknown as GruendungPersonengesellschaft21;
  }

  public convertBeteiligungPersonengesellschaft(oldNutzdaten: BeteiligungPersonengesellschaft): BeteiligungPersonengesellschaft21 {
    if (oldNutzdaten.partnerschaftsAngaben?.personenstand?.personenstand) {
      oldNutzdaten.partnerschaftsAngaben.personenstand.personenstand = this.convertPersonenstand(oldNutzdaten.partnerschaftsAngaben?.personenstand?.personenstand);
    }
    this.convertIntegerspecials4festsetzungVorauszahlungAngaben(oldNutzdaten.festsetzungVorauszahlungAngaben);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.beteiligungAngaben);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.bisherigePersoenlicheVerhaeltnisseAngaben?.bisherigeAdresse);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.empfangsbevollmaechtigterAngaben);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.personenAngaben);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.steuerlicheBeratungAngaben);
    this.convertToNumbersOnly4PartnerAddressesAtHausnummer(oldNutzdaten.partnerschaftsAngaben);

    console.log('nutzdaten nach dem convert:', cloneDeep(oldNutzdaten))

    return oldNutzdaten as unknown as BeteiligungPersonengesellschaft21;
  }

  public convertKoerperschaftNachAuslaendischemRecht(oldNutzdaten: KoerperschaftNachAuslaendischemRecht): KoerperschaftNachAuslaendischemRecht21 {
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('hausnummer', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('hoeheDerBeteiligungNominell', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('hoeheGrundStammkapital', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('daraufEingezahlt', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('summeAuftrag', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('voraussichtlicheLohnsteuer', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('geringfuegigBeschaeftigte', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('familienangehoerige', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('arbeitnehmer', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('gewerbeertragFj', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('gewerbeertrag', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('stAnrBetrFj', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('stAnrBetr', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('zuVerstEinkFj', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('zuVerstEink', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('gewinnFj', oldNutzdaten);
    this.updateNodeToInteger<KoerperschaftNachAuslaendischemRecht>('gewinn', oldNutzdaten);
    delete oldNutzdaten.nachreichungAngaben?.weitereBetriebstaetten;
    delete oldNutzdaten.nachreichungAngaben?.weitereOnlineMarktplaetze;
    oldNutzdaten.anteilseignerAngaben?.anteilseigner?.forEach(anteilseigner => {
      delete anteilseigner.weitereAngabenAnteilseigner?.gruendungsdatum;
    });
    return oldNutzdaten as unknown as KoerperschaftNachAuslaendischemRecht21;
  }

  public convertAufnameGewerblicheTaetigkeit(oldNutzdaten: AufnahmeGewerblicheTaetigkeit): AufnahmeGewerblicheTaetigkeit21 {
    delete oldNutzdaten.unternehmenAngaben?.grossempfaengeradresse;

    if (oldNutzdaten.partnerschaftsAngaben?.personenstand?.personenstand) {
      oldNutzdaten.partnerschaftsAngaben.personenstand.personenstand = this.convertPersonenstand(oldNutzdaten.partnerschaftsAngaben?.personenstand?.personenstand);
    }

    oldNutzdaten.betriebstaettenAngaben?.betriebstaetten.forEach(bs => {
      this.convertToNumbersOnly4StandartAddressesAtHausnummer<Betriebstaette>(bs);
    });

    // integer rule
    this.convertIntegerspecials4festsetzungVorauszahlungAngaben(oldNutzdaten.festsetzungVorauszahlungAngaben);

    this.convertToNumbersOnly<Inlandsadresse>(oldNutzdaten.gruendungsformAngaben?.vorherigesUnternehmenAdresse, 'hausnummer');
    this.convertToNumbersOnly<Inlandsadresse>(oldNutzdaten.lohnsteuerAngaben?.betriebstaetteInlandsadresse, 'hausnummer');
    this.convertToNumbersOnly<LohnsteuerAngaben>(oldNutzdaten.lohnsteuerAngaben, 'arbeitnehmer');
    this.convertToNumbersOnly<LohnsteuerAngaben>(oldNutzdaten.lohnsteuerAngaben, 'familienangehoerige');
    this.convertToNumbersOnly<LohnsteuerAngaben>(oldNutzdaten.lohnsteuerAngaben, 'geringfuegigBeschaeftigte');
    this.convertToNumbersOnly<LohnsteuerAngaben>(oldNutzdaten.lohnsteuerAngaben, 'voraussichtlicheLohnsteuer');
    this.convertToNumbersOnly<UmsatzsteuerAngaben>(oldNutzdaten.umsatzsteuerAngaben, 'summeUmsaetzeJahrBetriebseroeffnung');
    this.convertToNumbersOnly<UmsatzsteuerAngaben>(oldNutzdaten.umsatzsteuerAngaben, 'summeUmsaetzeFolgejahr');
    this.convertToNumbersOnly<UmsatzsteuerAngaben>(oldNutzdaten.umsatzsteuerAngaben, 'betrag');

    this.convertToNumbersOnly4PartnerAddressesAtHausnummer(oldNutzdaten.partnerschaftsAngaben);

    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.abweichenderOrtGeschaeftsleitungAngaben);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.unternehmenAngaben);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.bisherigePersoenlicheVerhaeltnisseAngaben?.bisherigeAdresse);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.empfangsbevollmaechtigterAngaben);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.personenAngaben);
    this.convertToNumbersOnly4StandartAddressesAtHausnummer(oldNutzdaten.steuerlicheBeratungAngaben);

    oldNutzdaten.organschaftAngaben?.organgesellschaften.forEach(og => {
      this.convertOrgangesellschaften(og);
    });

    return oldNutzdaten as unknown as AufnahmeGewerblicheTaetigkeit21;
  }

  private convertOrgangesellschaften(organgesellschaft: Organgesellschaft) {
      this.convertToNumbersOnly<Inlandsadresse>(organgesellschaft.inlandsadresse, 'hausnummer');
      this.convertToNumbersOnly<Organgesellschaft>(organgesellschaft, 'beteiligungsverhaeltnisZaehler');
      this.convertToNumbersOnly<Organgesellschaft>(organgesellschaft, 'beteiligungsverhaeltnisNenner');
  }

  private convertPersonenstand(oldValue: PersonenstandEnum) {
    switch(oldValue){
      case PersonenstandEnum._006:
        return PersonenstandEnum._002;
      case PersonenstandEnum._007:
        return PersonenstandEnum._004;
      case PersonenstandEnum._008:
        return PersonenstandEnum._005;
      default:
        return oldValue;
    }
  }

  private convertBeiEinkuenftenAusEnum (oldValue: BeiEinkunftenAusEnum) {
    switch (oldValue) {
      case BeiEinkunftenAusEnum._1:
        return BeiEinkunftenAusEnumLabels._13;
      case BeiEinkunftenAusEnum._2:
        return BeiEinkunftenAusEnumLabels._14;
      case BeiEinkunftenAusEnum._3:
        return BeiEinkunftenAusEnumLabels._15;
      default:
        return oldValue;
    }
  }

  // 1, 2 are not part of enumeration
  private convertArtDesBeteiligtenEnum(oldvalue: ArtDesBeteiligtenEnum) {
    switch (oldvalue) {
      case '1' as unknown as ArtDesBeteiligtenEnum:
        return '0' as unknown as ArtDesBeteiligtenEnum;
      case ArtDesBeteiligtenEnum._2:
        return ArtDesBeteiligtenEnumLabels._1;
      case ArtDesBeteiligtenEnum._4:
        return ArtDesBeteiligtenEnumLabels._5;
      default:
        return oldvalue;
    }
  }

  private convertToNumbersOnly<T>(obj: any, propName: keyof T): void {
    if (obj!! && !!obj[propName] && typeof obj[propName] === 'string') {
      const match = obj[propName].match(/^\d+/);
      if (match && match.length > 0) {
        obj[propName] = match[0];
      } else {
        obj[propName] = '';
      }
    }
  }

  private convertToNumbersOnly4PartnerAddressesAtHausnummer<T>(prop: T) {
    this.convertToNumbersOnly<Inlandsadresse>(prop?.['ehepartnerInlandsadresse'], 'hausnummer');
    this.convertToNumbersOnly<Auslandsadresse>(prop?.['ehepartnerAuslandsadresse'], 'hausnummer');
  }

  private convertToNumbersOnly4StandartAddressesAtHausnummer<T>(prop: T) {
    this.convertToNumbersOnly<Inlandsadresse>(prop?.['inlandsadresse'], 'hausnummer');
    this.convertToNumbersOnly<Auslandsadresse>(prop?.['auslandsadresse'], 'hausnummer');
  }

  private convertIntegerspecials4festsetzungVorauszahlungAngaben(festsetzungVorauszahlungAngaben: FestsetzungVorauszahlungAngaben): void {
    this.convertIntegerspecials4grundlageVorauszahlungen(festsetzungVorauszahlungAngaben?.landForstwirtschaft);
    this.convertIntegerspecials4grundlageVorauszahlungen(festsetzungVorauszahlungAngaben?.gewerbebetrieb);
    this.convertIntegerspecials4grundlageVorauszahlungen(festsetzungVorauszahlungAngaben?.selbstaendigerArbeit);
    this.convertIntegerspecials4grundlageVorauszahlungen(festsetzungVorauszahlungAngaben?.nichtSelbstaendigerArbeit);
    this.convertIntegerspecials4grundlageVorauszahlungen(festsetzungVorauszahlungAngaben?.kapitalvermoegen);
    this.convertIntegerspecials4grundlageVorauszahlungen(festsetzungVorauszahlungAngaben?.vermietungVerpachtung);
    this.convertIntegerspecials4grundlageVorauszahlungen(festsetzungVorauszahlungAngaben?.sonstigeEinkuenfte);
    this.convertIntegerspecials4grundlageVorauszahlungen(festsetzungVorauszahlungAngaben?.sonderausgaben);
    this.convertIntegerspecials4grundlageVorauszahlungen(festsetzungVorauszahlungAngaben?.steuerabzugsbetraege);
  }

  private convertIntegerspecials4grundlageVorauszahlungen(prop: GrundlageVorauszahlungen): void {
    this.convertToNumbersOnly<GrundlageVorauszahlungen>(prop, 'steuerpflichtigerJahrBetriebseroeffnung');
    this.convertToNumbersOnly<GrundlageVorauszahlungen>(prop, 'steuerpflichtigerFolgejahr');
    this.convertToNumbersOnly<GrundlageVorauszahlungen>(prop, 'ehepartnerJahrBetriebseroeffnung');
    this.convertToNumbersOnly<GrundlageVorauszahlungen>(prop, 'ehepartnerFolgejahr');
  }

  private updateNodeToInteger<T>(find, currentNode): T  {
    Object.keys(currentNode).forEach(key => {
      if (typeof currentNode[key] === 'object') {
        this.updateNodeToInteger(find, currentNode[key]);
      }
      if (key === find && typeof currentNode[key] === 'string') {
        const match = currentNode[key].match(/^\d+/);
        if (match && match.length > 0) {
          currentNode[key] = match[0];
        } else {
          currentNode[key] = '';
        }
      }
    });
    return currentNode;
  }

}

